import { Button } from "@heroui/react";
import { StatusMessage } from "./StatusMessage";

export const ValidationError = ({ onRetry }: { onRetry: () => void }) => (
  <>
    <StatusMessage>Something went wrong. Please try again.</StatusMessage>
    <Button
      size={"lg"}
      color={"secondary"}
      fullWidth={true}
      onPress={onRetry}
    >
      Retry
    </Button>
  </>
);
